// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select_container__vrlOg {
    position: relative;
    width: 100%;
}

.select_options-container__Qc7G2 {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 3px;
    background-color: var(--color-content);
    border: 1px solid var(--color-input-border);
    margin-top: 5px;
    width: 100%;
}

.select_small__7QK50 {
    max-width: 254px;
}



.select_custom-select__Mg4Lc {
    max-width: 254px;
    height: 26px;
    appearance: none;
    -webkit-appearance: none;
    width: 100%;
    background-color: var(--color-content);
    border: 1px solid var(--color-input-border);
    border-radius: 3px;
    color: var(--color-main-typography);
    cursor: pointer;
    outline: none;
    padding: 5px 10px 5px 10px;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.select_big-select__F320P {
    color: var(--color-main-typography);
    background: var(--color-content);
    outline: none;
    width: 100%;
    height: 38px;
    border: 1px solid var(--color-input-border);
    border-radius: 5px;
    padding: 10px 15px;
    font-size: 14px;
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.select_option-case__eceJx {
    background-color: var(--color-content);
    width: 100%;
    border-bottom: 1px solid var(--color-input-border);
    padding: 10px 20px 10px 20px;
    font-size: 12px;
    height: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
    gap: 10px;
}

.select_custom-select__Mg4Lc::-ms-expand {
    display: none;
  }
  

.select_custom-select__Mg4Lc:focus {
    outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/select/select.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,sCAAsC;IACtC,2CAA2C;IAC3C,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;IACX,sCAAsC;IACtC,2CAA2C;IAC3C,kBAAkB;IAClB,mCAAmC;IACnC,eAAe;IACf,aAAa;IACb,0BAA0B;IAC1B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,aAAa;IACb,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,kDAAkD;IAClD,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,aAAa;EACf;;;AAGF;IACI,aAAa;AACjB","sourcesContent":[".container {\n    position: relative;\n    width: 100%;\n}\n\n.options-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: 3px;\n    background-color: var(--color-content);\n    border: 1px solid var(--color-input-border);\n    margin-top: 5px;\n    width: 100%;\n}\n\n.small {\n    max-width: 254px;\n}\n\n\n\n.custom-select {\n    max-width: 254px;\n    height: 26px;\n    appearance: none;\n    -webkit-appearance: none;\n    width: 100%;\n    background-color: var(--color-content);\n    border: 1px solid var(--color-input-border);\n    border-radius: 3px;\n    color: var(--color-main-typography);\n    cursor: pointer;\n    outline: none;\n    padding: 5px 10px 5px 10px;\n    font-size: 12px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.big-select {\n    color: var(--color-main-typography);\n    background: var(--color-content);\n    outline: none;\n    width: 100%;\n    height: 38px;\n    border: 1px solid var(--color-input-border);\n    border-radius: 5px;\n    padding: 10px 15px;\n    font-size: 14px;\n    margin-top: 5px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.option-case {\n    background-color: var(--color-content);\n    width: 100%;\n    border-bottom: 1px solid var(--color-input-border);\n    padding: 10px 20px 10px 20px;\n    font-size: 12px;\n    height: 35px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: left;\n    gap: 10px;\n}\n\n.custom-select::-ms-expand {\n    display: none;\n  }\n  \n\n.custom-select:focus {\n    outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `select_container__vrlOg`,
	"options-container": `select_options-container__Qc7G2`,
	"small": `select_small__7QK50`,
	"custom-select": `select_custom-select__Mg4Lc`,
	"big-select": `select_big-select__F320P`,
	"option-case": `select_option-case__eceJx`
};
export default ___CSS_LOADER_EXPORT___;
